import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import React from "react";
import stl from "./CarChecked.module.css";
import { Link } from "react-router-dom";
import SharedPopUp from "@componentsShared/BottomSheetPopup__OLD/SharedPopUp";
import { useState } from "react";
import DeleteConfirmation from "./DeleteConfirmation";
import NeedHelp from "@/_MiniApps/NeedHelp/NeedHelp";
import { useEffect } from "react";
import { createTimestampAndNextNDays } from "@/utils/GlobalJavascriptFunction";
import { useLang } from "@/common/Contexts/LanguageContext";
var CarChecked = function CarChecked(_ref) {
  var pageData = _ref.pageData,
    t = _ref.t,
    requestId = _ref.requestId,
    navigate = _ref.navigate;
  var _useState = useState(false),
    ShowPopUp = _useState[0],
    setShowPopUp = _useState[1];
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    myTimestamp = _React$useState2[0],
    setMyTimestamp = _React$useState2[1];
  var lang = useLang();
  useEffect(function () {
    setMyTimestamp(createTimestampAndNextNDays(pageData === null || pageData === void 0 ? void 0 : pageData.timestamp));
  }, [pageData]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("i", {
    className: stl.appointmentIcon
  }), /*#__PURE__*/React.createElement("strong", null, pageData === null || pageData === void 0 ? void 0 : pageData.text), /*#__PURE__*/React.createElement("div", {
    className: stl.innerContainer
  }, /*#__PURE__*/React.createElement("strong", null, pageData === null || pageData === void 0 ? void 0 : pageData.title), myTimestamp && /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
    className: stl.calenderIcon
  }), /*#__PURE__*/React.createElement("strong", null, t("date", {
    ns: "web_Schedule"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.dayName(lang), " ", (myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.day()) + "/" + (myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.month()) + "/" + (myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.year()), " "))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
    className: stl.clockIcon
  }), /*#__PURE__*/React.createElement("strong", null, t("time", {
    ns: "web_Schedule"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, myTimestamp === null || myTimestamp === void 0 ? void 0 : myTimestamp.timeForView(lang))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("i", {
    className: stl.locationIcon
  }), /*#__PURE__*/React.createElement("strong", null, t("location", {
    ns: "web_Schedule"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_en) === "" && (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_ar) === "" && (pageData === null || pageData === void 0 ? void 0 : pageData.location)), /*#__PURE__*/React.createElement("span", null, lang === "ar" && (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_ar) && (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_ar) !== "" && (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_ar)), /*#__PURE__*/React.createElement("span", null, lang === "en" && (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_en) && (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_en) !== "" && (pageData === null || pageData === void 0 ? void 0 : pageData.company_location_name_en))))), /*#__PURE__*/React.createElement(Link, {
    to: "/",
    className: ["blueBtn", stl.btn].join(" ")
  }, t("go_homepage", {
    ns: "web_Schedule"
  }))), /*#__PURE__*/React.createElement(NeedHelp, {
    className: stl.helpContainer
  }), /*#__PURE__*/React.createElement(SharedPopUp, {
    maxWidth: "563px",
    show: ShowPopUp,
    onClose: function onClose() {
      setShowPopUp(false);
    }
  }, /*#__PURE__*/React.createElement(DeleteConfirmation, {
    request_id: requestId,
    t: t,
    closePopup: function closePopup() {
      return setShowPopUp(false);
    }
  })));
};
export default CarChecked;